export default {
    'the-classification': 'the classification',
    'edit-classification': 'Edit classification',
    'classification-name': 'Classification name',
    priority: 'Priority',
    'add-new-classification': 'Add new classification',
}